export default {

    inserted (el, binding) {
        const embedUrl = `https://www.youtube.com/embed/${binding.value}?rel=0&amp;autoplay=1`

        $(el).featherlight({
            iframe: embedUrl,
            iframeMaxWidth: '100%',
            iframeWidth: 960,
            iframeHeight: 540,
            iframeAllow: 'autoplay; encrypted-media',
            iframeAllowfullscreen: true,
            iframeFrameborder: 0
        })
    }
}
